import { render, staticRenderFns } from "./TextRevisions.vue?vue&type=template&id=2eeff856&scoped=true&"
import script from "./TextRevisions.vue?vue&type=script&lang=js&"
export * from "./TextRevisions.vue?vue&type=script&lang=js&"
import style0 from "./TextRevisions.vue?vue&type=style&index=0&id=2eeff856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeff856",
  null
  
)

export default component.exports